<template>
  <div>
    <div class="d-flex justify-content-between">
      <h6 class="text-lg text-main">
        {{ editorTitle }}
      </h6>
      <b-form-checkbox
        v-model="theme"
        class="custom-control-dark mb-2"
        name="check-button"
        switch
        value="vs-dark"
        unchecked-value="vs"
      >
        <span class="switch-icon-left"> <GjIcon name="Idea" /> </span>
        <span class="switch-icon-right"> <GjIcon name="Idea_fill" /> </span>
      </b-form-checkbox>
    </div>
    <custom-select
      v-if="changeableLanguage"
      v-model="selectedLanguage"
      class="r-dropdown col-2 p-0 mb-1"
      :options="getOptions(languageOptions)"
      @change="changeLanguage"
    />
    <div
      v-show="requestMethod !== 0 && requestMethod !== 1"
      :id="editorId"
      ref="editorContainer"
      class="monaco-wrapper text-left"
      :class="{ 'bg-black': theme }"
    />
    <div
      v-if="requestMethod === 0 || requestMethod === 1"
      class="d-flex mt-1"
    >
      <GjIcon name="Warning" />
      <p class="ml-1">
        {{ requestMethod === 0 ? 'Cannot send body with HEAD method!' : 'Cannot send body with GET method!' }}
      </p>
    </div>
  </div>
</template>

<script>
import loader from '@monaco-editor/loader'

export default {
  name: 'FormBodyEditor',
  components: {},
  props: {
    editable: {
      type: Boolean,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    editorTitle: {
      type: String,
      default: 'Request Body:',
    },
    editorId: {
      type: String,
      default: null,
      required: true,
    },
    requestMethod: {
      type: Number,
      default: null,
    },
    bodyValue: {
      type: String,
      default: null,
    },
    changeableLanguage: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      themeLight: this.theme,
      editor: null,
      language: 'json',
      selectedLanguage: 1,
      languageOptions: [
        {
          id: 0,
          value: 'html',
        },
        {
          id: 1,
          value: 'json',
        },
      ],
    }
  },
  computed: {
    theme: {
      get() {
        return this.$store.state.app.editorLightTheme
      },
      set(val) {
        this.$store.commit('app/SET_EDITOR_THEME', val)
      },
    },
  },
  watch: {
    theme() {
      this.changeTheme()
    },
    contentType() {
      this.changeLanguage()
    },
  },
  mounted() {
    const wrapper = document.getElementById(this.editorId)
    const value = this.bodyValue
    const language = this.details ? this.getLanguageFromValue(this.bodyValue) : this.getDefaultLanguage()
    loader.init().then(monaco => {
      this.editor = monaco.editor.create(wrapper, {
        value,
        language,
        theme: this.theme,
        readOnly: false,
        automaticLayout: true,
        wordWrap: 'on',
        wrappingIndent: 'indent',
      })
      this.delayAndFormatEditor()
    })
  },
  methods: {
    changeTheme() {
      loader.init().then(monaco => {
        monaco.editor.setTheme(this.theme)
      })
    },
    delayAndFormatEditor() {
      setTimeout(() => {
        this.editor
          .getAction('editor.action.formatDocument')
          .run()
          .then(() => (
            !this.editable
              ? this.editor.updateOptions({ readOnly: true })
              : null))
      }, 100)
    },
    getDefaultLanguage() {
      return this.contentType.toLowerCase().includes('json') ? 'json' : this.contentType
    },
    changeLanguage() {
      let language = this.getDefaultLanguage()
      if (this.changeableLanguage) {
        language = this.languageOptions.find(x => x.id === this.selectedLanguage)?.value
      }
      loader.init().then(monaco => {
        monaco.editor.setModelLanguage(this.editor.getModel(), language)
        this.delayAndFormatEditor()
      })
    },
    getLanguageFromValue(value) {
      try {
        JSON.parse(value)
        return 'json'
      } catch {
        return 'text/html'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.monaco-wrapper {
  height: 26vh;
  min-height: 300px;
  border-radius: 4px;
  box-shadow: 0px 0px 16px #e0e5eb;
  padding: 2px;
  background-color: none;

  .monaco-editor {
    width: auto !important;
  }
}
.custom-control-dark::v-deep {
  .custom-control-label {
    padding-left: 3rem;
    .switch-icon-right {
      right: 6px;
    }
  }
}
</style>
